import { Injectable } from '@angular/core'
import { Store, StoreConfig } from '@datorama/akita'
import { User } from '@app/core'

export interface SessionState {
  user: User | null
}

export function createInitialState(): SessionState {
  return {
    user: null,
  }
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'session' })
export class SessionStore extends Store<SessionState> {
  constructor() {
    super(createInitialState())
  }
}
